import Highcharts from "highcharts";

export const wiseDays = [
  {
    day: 1,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 2,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 3,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 4,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 5,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 6,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 7,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 8,
    risk: 1,
    low: 4500000,
    high: 5500000,
  },
  {
    day: 9,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 10,
    risk: 1,
    low: 4500000,
    high: 5500000,
  },
  {
    day: 11,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 12,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 13,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 14,
    risk: 2,
    low: 4000000,
    high: 6000000,
  },
  {
    day: 15,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 16,
    risk: 2,
    low: 4000000,
    high: 6000000,
  },
  {
    day: 17,
    risk: 2,
    low: 4000000,
    high: 6000000,
  },
  {
    day: 18,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 19,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 20,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 21,
    risk: 3,
    low: 3500000,
    high: 6500000,
  },
  {
    day: 22,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 23,
    risk: 3,
    low: 3500000,
    high: 6500000,
  },
  {
    day: 24,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 25,
    risk: 3,
    low: 3500000,
    high: 6500000,
  },
  {
    day: 26,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 27,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 28,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 29,
    risk: 4,
    low: 3000000,
    high: 7000000,
  },
  {
    day: 30,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 31,
    risk: 4,
    low: 3000000,
    high: 7000000,
  },
  {
    day: 32,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 33,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 34,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 35,
    risk: 5,
    low: 2500000,
    high: 7500000,
  },
  {
    day: 36,
    risk: 5,
    low: 2500000,
    high: 7500000,
  },
  {
    day: 37,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 38,
    risk: 5,
    low: 2500000,
    high: 7500000,
  },
  {
    day: 39,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 40,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 41,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 42,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 43,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 44,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 45,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 46,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 47,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 48,
    risk: 6,
    low: 1,
    high: 9999999,
  },
  {
    day: 49,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
  {
    day: 50,
    risk: 0,
    low: 5000000,
    high: 5000000,
  },
];

export function getCategoryDays(category) {
  let categories = new Map([
    [ "fixed", 0 ],
    [ "lowRisk", 1 ],
    [ "moderateRisk", 2 ],
    [ "mediumRisk", 3 ],
    [ "highRisk", 4 ],
    [ "veryHighRisk", 5 ],
    [ "extremeRisk", 6 ],
  ]);

  return wiseDays.filter(wiseDay => wiseDay.risk === categories.get(category)).map(wiseDay => wiseDay)
}

export function dayToDate(day) {
  let startTimestamp = Date.UTC(2020, 10, 11);
  let timestamp = startTimestamp + (day - 1) * 86400000;
  let dateString = Highcharts.dateFormat('%Y-%m-%d', timestamp);
  return dateString;
}

export function roundingTimestamp(timestamp, roundingFactor) {
  return Math.floor(timestamp / roundingFactor) * roundingFactor;
}
